module.exports = __webpack_public_path__ + "static/remember-the-milk-44236896c4194b9f50e7eb058c2c58a7.png";